import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { on } from "@ember/modifier";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import TaskForm from "glesys-controlpanel/components/task-form";
import Label from "glesys-controlpanel/components/label";
import GInput from "glesys-controlpanel/components/g-input";
import GButton from "glesys-controlpanel/components/g-button";

export default class ModalsBlockStorageRename extends Component {
  @service modal;

  get task() {
    return this.args.params.task;
  }

  get volume() {
    return this.args.params.volume;
  }

  @tracked name = this.volume?.name;

  onFormChange = ({ name }) => {
    this.name = name;
  };

  submitTask = task(async () => {
    await this.task.perform(this.name);

    this.modal.close();
  });

  <template>
    <Header>
      {{t "block-storage-volumes.details.modal.rename"}}
    </Header>
    <Body>
      <TaskForm
        id="rename"
        data-test-input-field-for-volume-name
        @onChange={{this.onFormChange}}
        @task={{this.submitTask}}
      >
        <Label for="name">
          {{t "label.name"}}
        </Label>
        <GInput
          id="name"
          data-test-rename-block-storage-volume
          name="name"
          value={{this.name}}
          placeholder={{this.volume.name}}
          {{! eslint-disable-next-line ember/template-no-autofocus-attribute }}
          autofocus
          required
        />
      </TaskForm>
    </Body>
    <Footer>
      <GButton class="mr-2" @type="button" @color="gray" {{on "click" (modalClose)}}>
        {{t "button.close"}}
      </GButton>
      <GButton data-test-block-storage-rename-submit @type="submit" @color="blue" form="rename">
        {{t "button.update"}}
      </GButton>
    </Footer>
  </template>
}
